import { BaseRouteService } from 'core/services';

class SyncRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'sync/';
	}

	syncByChannelAsync(id, sourceOfChange) {
		return super.get(this.base + 'sync-by-channel/{id}/?sourceOfChange={sourceOfChange}', id, { sourceOfChange });
	}

	syncAsync(sourceOfChange) {
		return super.get(this.base + 'sync/?sourceOfChange={sourceOfChange}', null, { sourceOfChange });
	}
}

export default SyncRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/SyncRouteService.js